import { render, staticRenderFns } from "./EventsTableCard.vue?vue&type=template&id=dc39e988&"
import script from "./EventsTableCard.vue?vue&type=script&lang=ts&"
export * from "./EventsTableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports